// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { i18n } from '@lingui/core';
import moment from 'moment';
import { BookitupNotification } from '../../../../Types/LogT';
import { RoutingS } from '../../../../Service/RoutingS';
import LinkText from '../../../../Atoms/LinkText';

const ApprovalRequired: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { personDescription, value, eventDate, eventId } = notification;

  return (
    <Text>
      Der Workflow {i18n._(`actionType.${value}`)} muss für das{' '}
      <LinkText span weight="bolder" onClick={() => RoutingS.openInNewTab(`/events/${eventId}/details`)}>
        Event
      </LinkText>{' '}
      {eventDate && (
        <>
          am
          <Text span weight="bolder">
            {` ${moment(eventDate).format('LL')}`}
          </Text>
        </>
      )}
      {'  '}mit
      <Text span weight="bolder">
        {` ${personDescription} `}
      </Text>
      genehmigt werden.
    </Text>
  );
};

export default ApprovalRequired;
